import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Contato from "@/pages/Contato";
import Privacidade from "@/pages/Privacidade";
import Termos from "@/pages/Termos";
import ExclusaoDeDados from "@/pages/ExclusaoDeDados";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="/termos" element={<Termos />} />
        <Route path="/exclusao-de-dados" element={<ExclusaoDeDados />} />
        {/* Rota provisória: mapeador ainda não público — redireciona para contato */}
        <Route path="/diagnostico" element={<Navigate to="/contato" replace />} />
        {/* Rotas inexistentes: 404 real (sem wildcard para Home) */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
